export default "__VITE_ASSET__9177c3a1__"